// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBvR7uCf8nH7HbEb9D9y_3lbYvz7EkMFZg",
  authDomain: "trainlocation-eee32.firebaseapp.com",
  databaseURL: "https://trainlocation-eee32-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "trainlocation-eee32",
  storageBucket: "trainlocation-eee32.firebasestorage.app",
  messagingSenderId: "127801590352",
  appId: "1:127801590352:web:4a1d38a23f82644b3e4755"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Realtime Database and get a reference to the service
export const database = getDatabase(app);

export default app; 